import { matchPath } from "react-router-dom";
// hooks
import { usePathname } from "src/routes/hook";

// ----------------------------------------------------------------------

export function useActiveLink(path, deep = true) {
    const pathname = usePathname();

    const _path = ( path || "" ).split("#")?.[ 0 ] || "";

    const normalActive = _path ? !!matchPath({ path: _path, end: true }, pathname) : false;

    const deepActive = _path ? !!matchPath({ path: _path, end: false }, pathname) : false;

    return deep ? deepActive : normalActive;
}
